var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.ActivityType
export let CreditActivityType = /*#__PURE__*/function (CreditActivityType) {
  CreditActivityType["ACTIVATE"] = "ACTIVATE";
  CreditActivityType["ADJUST_DECREMENT"] = "ADJUST_DECREMENT";
  CreditActivityType["ADJUST_INCREMENT"] = "ADJUST_INCREMENT";
  CreditActivityType["MODIFY_VALIDITY"] = "MODIFY_VALIDITY";
  CreditActivityType["PACK_REFUND"] = "PACK_REFUND";
  CreditActivityType["REDEEM_COMPLETED"] = "REDEEM_COMPLETED";
  CreditActivityType["REDEEM_PENDING"] = "REDEEM_PENDING";
  CreditActivityType["REDEMPTION_REFUND"] = "REDEMPTION_REFUND";
  return CreditActivityType;
}({});
// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.CreditActivity
let CreditActivity = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = fragment('activate-activity-details-fragment'), _dec7 = fragment('adjust-decrement-activity-details-fragment'), _dec8 = fragment('adjust-increment-activity-details-fragment'), _dec9 = fragment('modify-validity-activity-details-fragment'), _dec10 = fragment('redeem-completed-activity-details-fragment'), _dec11 = fragment('redeem-pending-activity-details-fragment'), _dec12 = fragment('refund-activity-details-fragment'), (_class = class CreditActivity extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "createdAt", _descriptor, this);
    _initializerDefineProperty(this, "creditPackId", _descriptor2, this);
    _initializerDefineProperty(this, "resultingQuantity", _descriptor3, this);
    // Only present if the activity status is COMPLETED
    _initializerDefineProperty(this, "type", _descriptor4, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor5, this);
    // Only populated if type is ACTIVATE
    _initializerDefineProperty(this, "activateActivityDetails", _descriptor6, this);
    // Only populated if type is ADJUST_DECREMENT
    _initializerDefineProperty(this, "adjustDecrementActivityDetails", _descriptor7, this);
    // Only populated if type is ADJUST_INCREMENT
    _initializerDefineProperty(this, "adjustIncrementActivityDetails", _descriptor8, this);
    // Only populated if type is MODIFY_VALIDITY
    _initializerDefineProperty(this, "modifyValidityActivityDetails", _descriptor9, this);
    // Only populated if type is REDEEM_COMPLETED
    _initializerDefineProperty(this, "redeemCompletedActivityDetails", _descriptor10, this);
    // Only populated if type is REDEEM_PENDING
    _initializerDefineProperty(this, "redeemPendingActivityDetails", _descriptor11, this);
    // Only populated if type is REDEMPTION_REFUND
    _initializerDefineProperty(this, "refundActivityDetails", _descriptor12, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "creditPackId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "resultingQuantity", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "activateActivityDetails", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "adjustDecrementActivityDetails", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "adjustIncrementActivityDetails", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "modifyValidityActivityDetails", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "redeemCompletedActivityDetails", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "redeemPendingActivityDetails", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "refundActivityDetails", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { CreditActivity as default };
CreditActivity.reopenClass({
  _modelNameForMigration: 'credit-activity'
});